import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Trash2, Upload, X } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };
const errText = (err, f) => { const d = err.response?.data?.detail; return typeof d === "string" ? d : f; };

export const useSignature = (church) => {
  const [sig, setSig] = useState({ url: "", treasurer_name: "" });
  const load = useCallback(async () => {
    try {
      const info = (await axios.get(`${API}/signatures/info?church=${encodeURIComponent(church)}`, cfg)).data;
      if (!info.has_signature) return setSig({ url: "", treasurer_name: "" });
      const img = await axios.get(`${API}/signatures/image?church=${encodeURIComponent(church)}`, { ...cfg, responseType: "blob" });
      setSig({ url: URL.createObjectURL(img.data), treasurer_name: info.treasurer_name });
    } catch { setSig({ url: "", treasurer_name: "" }); }
  }, [church]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => () => sig.url && URL.revokeObjectURL(sig.url), [sig.url]);
  return [sig, load];
};

const Preview = ({ saving, url }) => {
  if (saving) return <span>Enviando assinatura...</span>;
  if (url) return <img src={url} alt="Assinatura" />;
  return <span>Nenhuma assinatura cadastrada</span>;
};

export const SignatureModal = ({ user, churches, onClose }) => {
  const [church, setChurch] = useState(user.role === "admin" ? churches[0] : user.church);
  const [sig, reload] = useSignature(church);
  const [file, setFile] = useState(null);
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setName(sig.treasurer_name); }, [sig.treasurer_name]);
  const upload = async (e) => {
    e.preventDefault(); if (!file) return toast.error("Escolha a imagem da assinatura");
    const fd = new FormData(); fd.append("file", file); fd.append("church", church); fd.append("treasurer_name", name);
    setSaving(true);
    try { await axios.post(`${API}/signatures`, fd, cfg); await reload(); toast.success("Assinatura salva"); setFile(null); }
    catch (err) { toast.error(errText(err, "Não foi possível enviar a assinatura.")); } finally { setSaving(false); }
  };
  const remove = async () => { if (!window.confirm("Remover a assinatura desta igreja?")) return; await axios.delete(`${API}/signatures?church=${encodeURIComponent(church)}`, cfg); toast.success("Assinatura removida"); reload(); };
  return <div className="modal-backdrop"><div className="modal small-modal" data-testid="signature-modal">
    <button data-testid="signature-modal-close-button" className="icon-btn close" onClick={onClose}><X /></button>
    <p className="eyebrow">RECIBOS</p><h2>Assinatura do tesoureiro</h2>
    <form onSubmit={upload}>
      {user.role === "admin" ? <label>Igreja<select data-testid="signature-church-select" value={church} onChange={e => setChurch(e.target.value)}>{churches.map(c => <option key={c}>{c}</option>)}</select></label> : <label>Igreja<input value={user.church} readOnly /></label>}
      <div className="signature-preview" data-testid="signature-preview"><Preview saving={saving} url={sig.url} /></div>
      <label>Nome do tesoureiro<input data-testid="signature-treasurer-input" value={name} onChange={e => setName(e.target.value)} placeholder="Nome que aparece abaixo da assinatura" /></label>
      <label>Imagem da assinatura (PNG, JPG ou WEBP, até 2 MB)<input data-testid="signature-file-input" type="file" accept="image/png,image/jpeg,image/webp" onChange={e => setFile(e.target.files[0] || null)} /></label>
      <button data-testid="signature-upload-button" className="primary-btn" disabled={saving}><Upload size={16} /> {saving ? "Enviando..." : "Salvar assinatura"}</button>
      {sig.url && <button data-testid="signature-delete-button" type="button" className="secondary-btn danger-text" onClick={remove}><Trash2 size={15} /> Remover assinatura</button>}
    </form>
  </div></div>;
};
